import { Edit } from '@mui/icons-material';
import { ListItemIcon, MenuItem } from '@mui/material';
import { FC } from 'react';
import { OpenEditType } from '@/types/subroutine';

type SubroutineEditMenuItemProps = {
  subroutineId?: number;
  folderId?: number;
  openEdit: (openEdit: OpenEditType) => void;
  onClose: () => void;
};

const SubroutineEditMenuItem: FC<SubroutineEditMenuItemProps> = (props) => {
  return (
    <MenuItem
      onClick={(e) => {
        props.openEdit({ open: true, id: props.subroutineId, folder: props.folderId, type: 'edit' });
        props.onClose();
      }}
    >
      <ListItemIcon>
        <Edit fontSize='small' />
      </ListItemIcon>
      Edit...
    </MenuItem>
  );
};

export default SubroutineEditMenuItem;
